import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useShowController } from 'react-admin';
import { Button, DeleteButton, EditLinkButton } from 'shared/mui/Buttons';
import { UserActionsIconButton } from 'shared/mui/IconButtons/UserActionsIconButton/UserActionsIconButton';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { CompanyShowDialogChipFields as CompanyShowChipFields } from 'shared/widgets/CompanyShowDialog/CompanyShowDialogChipFields';
import { CompanyShowDialogTable as CompanyShowTable } from 'shared/widgets/CompanyShowDialog/CompanyShowDialogTable';
import { Company } from 'types/embedded/company';
import { Permission } from 'types/embedded/permission';

import { CompaniesArchiveDialog } from './components/CompaniesArchiveDialog/CompaniesArchiveDialog';
import { CompaniesDeleteDialog } from './components/CompaniesDeleteDialog/CompaniesDeleteDialog';
import { CompaniesUnarchiveDialog } from './components/CompaniesUnarchiveDialog/CompaniesUnarchiveDialog';

export const CompaniesShow = () => {
  const translate = useTypedTranslate();
  const { hasResourcePermissions, hasResourceAccess } = usePermissions();
  const { record } = useShowController();

  const {
    handleOpenRecordModal: handleOpenRecordModalDelete,
    openRecordModal: openRecordModalDelete,
    handleCloseRecordModal: handleCloseRecordModalDelete,
  } = useRecordModal<Company>();

  const {
    handleOpenRecordModal: handleOpenRecordModalArchive,
    openRecordModal: openRecordModalArchive,
    handleCloseRecordModal: handleCloseRecordModalArchive,
  } = useRecordModal<Company>();

  const {
    handleOpenRecordModal: handleOpenRecordModalUnarchive,
    openRecordModal: openRecordModalUnarchive,
    handleCloseRecordModal: handleCloseRecordModalUnarchive,
  } = useRecordModal<Company>();

  return (
    <>
      <ShowPage
        actions={
          hasResourceAccess(Resources.UserActions)
            ? [<UserActionsIconButton entityName="company" key="user-action-link" />]
            : undefined
        }
        listName={translate('app.companies.titleText')}
        rightActionsSlot={[
          hasResourcePermissions(Resources.Companies, [Permission.Full, Permission.Delete]) &&
            (record?.archive ? (
              <DeleteButton onClick={() => handleOpenRecordModalDelete()} variant="outlined" />
            ) : (
              <DeleteButton
                label="Архивировать"
                onClick={() => handleOpenRecordModalArchive()}
                variant="outlined"
              />
            )),
          hasResourcePermissions(Resources.Companies, [Permission.Full, Permission.Update]) &&
            (record?.archive ? (
              <Button
                key="archive-button"
                label="восстановить"
                onClick={() => handleOpenRecordModalUnarchive()}
                variant="contained"
              />
            ) : (
              <EditLinkButton key="edit-button" label="Редактировать" variant="contained" />
            )),
        ]}
        sx={{ maxWidth: '1087px' }}
        title={translate('app.companies.details')}
      >
        <CompanyShowChipFields />
        <CompanyShowTable />
      </ShowPage>
      {openRecordModalDelete && (
        <CompaniesDeleteDialog
          onClose={handleCloseRecordModalDelete}
          open={openRecordModalDelete}
          record={record}
        />
      )}
      {openRecordModalArchive && (
        <CompaniesArchiveDialog
          isToRootOnSuccess={true}
          onClose={handleCloseRecordModalArchive}
          open={openRecordModalArchive}
          record={record}
        />
      )}
      {openRecordModalUnarchive && (
        <CompaniesUnarchiveDialog
          onClose={handleCloseRecordModalUnarchive}
          open={openRecordModalUnarchive}
          record={record}
        />
      )}
    </>
  );
};
